import { CartItemDto } from "@/types/dto/cart-item-dto";
import { atom } from "recoil";

export interface SameCartItemModal {
  cartItems: CartItemDto[];
  errors: { id: number; message: string }[];
}

export const isOpenSameCartItemModal = atom<SameCartItemModal>({
  key: "isOpenSameCartItemModal",
  default: {
    cartItems: [],
    errors: [],
  },
});
